import React, { useCallback } from "react";

import { useNavigate } from "react-router-dom";

import { Button, ButtonProps, SxProps } from "@mui/material";

export interface HeaderButtonProps extends ButtonProps {
  url: string;
  sx?: SxProps;
}

const HeaderButton = ({ url, sx, ...props }: HeaderButtonProps) => {
  const navigate = useNavigate();
  const handleClick = useCallback(() => navigate(url), [url]);

  return (
    <Button
      color="inherit"
      sx={{
        justifyContent: "flex-start",
        fontFamily: "Work Sans",
        lineHeight: "16px",
        color: "white",
        "&:hover": {
          backgroundColor: "transparent",
        },
        padding: "0",
        minWidth: "36px",
        ...sx,
      }}
      onClick={handleClick}
      {...props}
    />
  );
};

export default HeaderButton;
